import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icon, Input } from 'semantic-ui-react';
import { fetchCurrentAdvisorClients } from '../../../actions/advisor.actions';
import { sysAPI } from '../../../apis/SysAPI';
import { fpalphaAPI } from '../../../apis/FPAlphaAPI';
import { setSnackbar } from '../../../actions/snackbar.actions';

const ImportClients = () => {
  const dispatch = useDispatch();
  const selectFPClientFileInput = useRef();
  const [loaderUpload, setLoaderUpload] = useState(false);
  const advisorProfile = useSelector((state) => state.currentAdvisorProfile);

  const importFPClientInput_Change = async (e) => {
    console.log({ e });
    if (e.target.files?.length === 0) {
      return;
    }
    setLoaderUpload(true);
    try {
      const confirm = window.confirm(`Please confirm you want to inject the client included in ${e.target.files[0].name} to ${advisorProfile.fullName}.`);
      if (confirm) {
        const { data } = await sysAPI.post('/generate-code');
        const form = new FormData();
        form.append('fpclientSrc', e.target.files[0]);
        form.append('code', data.code);
        form.append('targetAdvisorId', advisorProfile._id);

        // eslint-disable-next-line
        const { data: dataImported } = await fpalphaAPI.post('/advisor/clientlist/add-prefilled', form, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        const message = dataImported?.message || `Clients were added to ${advisorProfile.fullName} successfully.`
        dispatch(setSnackbar({message: message}))
        dispatch(fetchCurrentAdvisorClients(advisorProfile?._id));
      }
    } catch (error) {
      console.error({ error });
      const message = error?.response?.data?.message || `Something went wrong while adding ${e.target.files[0].name} clients to ${advisorProfile.fullName}.`
      dispatch(setSnackbar({message: message, status: "error"}))
    }
    e.target.value = null;
    setLoaderUpload(false);
  };

  const importFPClientBtn_Click = () => {
    selectFPClientFileInput.current.inputRef.current.click();
  };

  return (
    <>
      <Button icon color="blue" labelPosition="left" onClick={importFPClientBtn_Click} loading={loaderUpload}>
        <Icon name="file" />
        Import .fpclient
      </Button>

      <Input type="file" ref={selectFPClientFileInput} style={{ display: 'none' }} onChange={importFPClientInput_Change} />
    </>
  );
};
export default ImportClients;
